export const SET_SCRAPING_RUNS = "SET_SCRAPING_RUNS";